import { render } from "./BannerTournament.vue?vue&type=template&id=efe21b32&scoped=true"
import script from "./BannerTournament.vue?vue&type=script&lang=js"
export * from "./BannerTournament.vue?vue&type=script&lang=js"

import "./BannerTournament.vue?vue&type=style&index=0&id=efe21b32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe21b32"]])

export default __exports__